/**
 * Helper to check if we should use mock data
 * This is used across all API files
 * Works in all environments: development, demo, and production
 *
 * PERMANENTLY DISABLED: Mock data is completely disabled - always use real backend APIs
 * Mocks will not work regardless of environment variables
 */
export const USE_MOCKS = false; // Permanently disabled - always using real backend APIs

export const useMockData = <T>(mockData: T, apiCall: () => Promise<T>): Promise<T> => {
  if (USE_MOCKS) {
    // Mock data is being used
    return Promise.resolve(mockData);
  }
  return apiCall().catch((error) => {
    console.warn('API call failed, using mock data:', error);
    return mockData;
  });
};
